import { render, staticRenderFns } from "./AutoQaMain.vue?vue&type=template&id=1068155f&scoped=true&"
import script from "./AutoQaMain.vue?vue&type=script&lang=js&"
export * from "./AutoQaMain.vue?vue&type=script&lang=js&"
import style0 from "./AutoQaMain.vue?vue&type=style&index=0&id=1068155f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068155f",
  null
  
)

export default component.exports